import { styled, component, hexToRgba } from '../../utils/style';
import { StyleColor } from '../../utils/styles-constants';

const TooltipContent = styled()(component.div, 'TooltipContent') `
	padding: 4px;
	border-radius: 4px;
	font-size: 12px;
	background-color: ${props => {
		const opacity = props.theme.primary.topnavOpacity ? props.theme.primary.topnavOpacity : 100;
		return hexToRgba(props.theme.primary.topnavColor, opacity);
	}};
	color: ${props => {
		const opacity = props.theme.primary.topnavOpacity ? props.theme.primary.topnavOpacity : 100;
		const iconsColor = props.theme.primary.iconsColor ? props.theme.primary.iconsColor : StyleColor.Black;
		return hexToRgba(iconsColor, opacity);
	}};
	border: 1px solid ${StyleColor.Grey100};
`;

export { TooltipContent };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Tooltip/styles.ts